import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { authService } from '../services/api';
import BrandPanel from '../components/BrandPanel';
import Logo from '../components/Logo';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { Button, Input, Field } from '../components/ui';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.requestPasswordReset(email);
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex bg-surface-50">
      <BrandPanel />

      <div className="flex-1 flex items-center justify-center px-6 py-12 relative">
        <div
          className="absolute right-4 sm:right-6"
          style={{ top: 'max(1rem, calc(env(safe-area-inset-top) + 0.5rem))' }}
        >
          <LanguageSwitcher />
        </div>

        <div className="max-w-sm w-full">
          <Link to="/" className="mb-8 lg:hidden inline-block">
            <Logo size={36} textColor="text-gray-900" />
          </Link>

          {sent ? (
            <>
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-5">
                <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold font-display tracking-tight text-gray-900">{t('Check your email')}</h2>
              <p className="text-sm text-gray-500 mt-2 mb-8">
                {t('If an account exists for {{email}}, a password reset link is on its way.', { email })}
              </p>
              <Link to="/login" className="text-sm text-primary-600 font-medium hover:underline">
                {t('Back to Login')}
              </Link>
            </>
          ) : (
            <>
              <h2 className="text-2xl font-bold font-display tracking-tight text-gray-900">{t('Forgot password?')}</h2>
              <p className="text-sm text-gray-500 mt-1 mb-8">
                {t("Enter your email and we'll send you a link to reset your password.")}
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <Field label={t('Email')} required>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </Field>

                <Button type="submit" loading={loading} className="w-full" size="lg">
                  {t('Send Reset Link')}
                </Button>
              </form>

              <p className="text-center mt-6 text-sm text-gray-500">
                <Link to="/login" className="text-primary-600 font-medium hover:underline">
                  {t('Back to Login')}
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
